import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";
import { IonicModule } from "@ionic/angular";
import { SuccessPaymentPage } from "./success-payment/success-payment";
import { InstantPaymentPage } from "./instant-payment";
import { FormsModule } from "@angular/forms";
const routes: Routes = [
    { path: 'success-payment', loadComponent: () =>
      import('./success-payment/success-payment').then(m => m.SuccessPaymentPage)
    },
    { path: 'instant-payment', loadComponent: () =>
      import('./instant-payment').then(m => m.InstantPaymentPage)
    }
  ];
@NgModule({
    declarations: [
      SuccessPaymentPage,
      InstantPaymentPage
    ],
    imports: [
        HttpClientModule,
        SharedModule,
        CommonModule,
        RouterModule,
        FormsModule,
        SharedModule,
        IonicModule,
        TranslateModule,
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
    ]
  })
  export class PaymentModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }